import { useContext, useMemo } from 'react';

import { FlagMessageContext } from './flag-message-context';

export const useFlagData = (intl) => {
  return useMemo(() => {
    return [
      {
        title: intl.formatMessage({
          id: 'stream.reasons.scam_or_spam',
          defaultMessage: 'Scam or spam'
        }),
        value: 'Scam or spam',
        categories: [
          {
            title: intl.formatMessage({
              id: 'stream.reasons.pay_outside_of_peerspace',
              defaultMessage: 'They asked me to pay outside of Peerspace'
            }),
            value: 'They asked me to pay outside of Peerspace'
          },
          {
            title: intl.formatMessage({
              id: 'stream.reasons.communicate_outside_peerspace',
              defaultMessage: 'They asked me to communicate outside of Peerspace'
            }),
            value: 'They asked me to communicate outside of Peerspace'
          },
          {
            title: intl.formatMessage({
              id: 'stream.reasons.advertised_or_solicited_something',
              defaultMessage: 'They advertised or solicited something'
            }),
            value: 'They advertised or solicited something'
          }
        ]
      },
      {
        title: intl.formatMessage({
          id: 'stream.reasons.offensive',
          defaultMessage: 'Offensive'
        }),
        value: 'Offensive'
      },
      {
        title: intl.formatMessage({
          id: 'stream.reasons.something_else',
          defaultMessage: 'Something else'
        }),
        value: 'Something else'
      }
    ];
  }, [intl.locale]);
};

export const useFlagMessageContext = () => useContext(FlagMessageContext);
